import { createQueryKeyFactory } from '@/utils/queries'

const tagsQueryKeys = createQueryKeyFactory(['tags'])
const tagFoldersQueryKeys = createQueryKeyFactory([...tagsQueryKeys.all, 'folders'])

export default {
    ...tagsQueryKeys,
    folders: tagFoldersQueryKeys
}
